import React from 'react';
import * as _ from 'lodash';
import { FieldImageService } from '../../../services/FieldImages';
import SessionStorageService from '../../../services/utilities/SessionStorageService';
import InfinityScrollLoad from '../../InfinityScrollLoad';
import {
  DROPDOWN_SEARCH_DEBOUNCE_TIMEOUT,
  REQUEST_PARAMS,
  DISPLAY_FLAG
} from '../../../utilities/constants';
import { messageUtility } from '../../../utilities/messageUtility';
import { FormElement } from '../../CommonFormComponents';
import { ArrowDownIcon } from '../../icons/ArrowDownIcon';
import { TrashIcon } from '../../icons/TrashIcon';

import { RadioButtonIcon } from '../../icons/RadioButtonIcon';
import { FormDropdownClearButton } from '../../CommonFormComponents';
/**
 * @description 指示書用キープランドロップダウン
 *              揚重機、機材マスタ登録、編集画面で使用
 */
export class FieldImagesKeyplanMasterDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fieldId: SessionStorageService.getFieldId(), // 現場ID
      loaded: false, // ページング用ロードフラグ
      opened: false, // 開閉フラグ
      selected: {}, // 選択キープラン情報
      options: [], // 取得キープラン情報
      // 検索条件キープラン名
      condition: {
        name: '',
      },
      // ラジオボタンチェック用キープラン情報
      checked: {
        category_code: null,
      },
      isLoading: true, // ロード中フラグ
    };

    this.initializeLoaded = false; // 編集画面用初期ロードフラグ

    this.id = Math.floor(Math.random() * 100000);
    this.targetId = `infinityscroll-target-field-image-keyplan-${this.id}`;
    this.search = this.search.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.setCondition = this.setCondition.bind(this);
    this.handleSelectedRow = this.handleSelectedRow.bind(this);
    this.selectKeyplan = this.selectKeyplan.bind(this);
    this.getFieldImageskeyplan = this.getFieldImageskeyplan.bind(this);
    this.parent = React.createRef();
    this.handleClickOutsideOfComponent = this.handleClickOutsideOfComponent.bind(
      this
    );
    this.searchTimer;
  }

  componentDidMount() {
    this.getFieldImageskeyplan(() => {});
  }

  componentDidUpdate() {
    if (this.state.opened === true) {
      // コンポーネントが可視状態の場合、clickイベントをセット
      document.addEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }
    if (this.state.opened === false) {
      // コンポーネントが不可視状態の場合、clickイベントを削除
      document.removeEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.formFlg === true &&
      this.initializeLoaded === false &&
      !_.isNull(nextProps.value)
    ) {
      // キープランを設定している編集画面遷移直後のみ実行
      // 選択しているキープラン情報をstateに格納
      const { options } = { ...this.state };
      const selectKeyplan = _.find(
        options,
        obj => obj.category_code === nextProps.value
      );
      this.initializeLoaded = true;

      if (!_.isUndefined(selectKeyplan)) {
        this.setState({ selected: selectKeyplan, checked: selectKeyplan });
      } else {
        this.props.set({ category_code: null, image_url: '' });
      }
    }
  }

  /**
   * @description クリックした場所を判定
   */
  handleClickOutsideOfComponent = e => {
    // コンポーネント内クリックの場合は無視する
    if (
      !_.isNull(this.parent.current) &&
      this.parent.current.contains(e.target)
    ) {
      return;
    }
    // コンポーネント外クリックの場合はドロップダウンを不可視とする
    // イベントはstateにfalseが設定された際にremoveされる
    this.setState({ opened: false });
  };

  /**
   * @description ドロップダウンの開閉状態を設定
   */
  handleOpen = () => {
    this.setState({ opened: !this.state.opened });
  };

  /**
   * @description 検索するキープラン名を設定
   * @param {string} keyplanName キープラン名
   */
  setCondition = keyplanName => {
    const { condition } = { ...this.state };
    condition.name = keyplanName;
    this.setState({ condition }, () => {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.search();
      }, DROPDOWN_SEARCH_DEBOUNCE_TIMEOUT);
    });
  };

  /**
   * @description キープランを検索
   */
  search = () => {
    let { options, loaded } = { ...this.state };
    options = [];
    loaded = false;

    this.getFieldImageskeyplan(() => {}, { options, loaded });
    this.setState({ options, loaded, isLoading: true });
  };

  /**
   * @description ラジオボタンチェック：未選択の場合、項目を選択する。選択中の場合、未選択にする。
   * @param {object} option キープラン情報
   */
  handleSelectedRow = option => {
    this.setState(
      {
        checked: option,
      },
      () => {
        this.selectKeyplan(option);
      }
    );
  };

  clearSelectedRow = () => {
    this.setState(
      { checked: { category_code: null }, selected: {}, opened: false },
      () => {
        this.props.set({ category_code: null, image_url: '' });
      }
    );
  };

  /**
   * @description キープラン選択：未選択の場合、項目を選択する。選択中の場合、未選択にする。
   * @param {object} checked キープラン情報
   */
  selectKeyplan = checked => {
    const isSelected = checked.category_code !== null;
    const defaultState = { category_code: null, image_url: '' };

    this.props.set(isSelected ? checked : defaultState);
    this.setState({
      selected: isSelected ? checked : {},
      opened: false,
    });
  };

  /**
   * @description キープラン情報取得
   * @param {*} notify
   * @param {object} init 再読み込み設定
   *                      検索キープラン名を設定時に使用
   */
  getFieldImageskeyplan(notify, init = {}) {
    const loaded = _.isEmpty(init) ? this.state.loaded : init.loaded;
    const options = _.isEmpty(init)
      ? _.cloneDeep(this.state.options)
      : init.options;

    if (loaded) {
      notify();
      this.setState({ isLoading: false });
      return;
    }

    const params = {
      field_id: this.state.fieldId,
      limit: REQUEST_PARAMS.parentLimit,
      offset: _.size(options),
      name: this.state.condition.name,
      display_flag: DISPLAY_FLAG.use.id,
    };

    FieldImageService.keyplan(this.state.fieldId, params).then(response => {
      if (response.result) {
        const fieldImages = response.data.entities.field_images;
        if (_.isEmpty(fieldImages)) {
          this.setState({ loaded: true });
        } else {
          _.each(fieldImages, image => {
            options.push(image);
          });
          this.setState({
            options,
            loaded: false,
          });
        }
        this.setState({ isLoading: false });
        notify();
      }
    });
  }

  deleteKeyplan = () => {
    this.props.set({ category_code: null, image_url: '' });
    this.setState({
      selected: {},
      opened: false,
      checked: {
        category_code: null,
      },
    });
  };

  render() {
    const { checked, selected, options, opened } = this.state;

    return (
      <FormElement validate={this.props.error}>
        <div
          id='form-dropdown'
          className='dropdown-multi-select'
          onKeyPress={e => {
            if (e.key === 'Enter') {
              e.preventDefault();
            }
          }} 
          ref={this.parent}
        >
          <div
            className={
              opened
                ? 'dropdown-multi-select__header show'
                : 'dropdown-multi-select__header'
            }
          >
            <div
              id='form-dropdown-btn'
              className='dropdown-select'
              onClick={() => this.handleOpen()}
            >
              <span className='dropdown-select__txt'>
                {!_.isEmpty(selected)
                  ? `${checked.label} : ${checked.comment}`
                  : 'キープランを選択'}
              </span>
              <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
            </div>
          </div>
          {opened && (
            <div
              id='form-dropdown-list'
              className='dropdown dropdown--dropdown-list show'
            >
              <div className='dropdown__item dropdown__item--hidden'>
                <div className='dropdown-single-select__item'>
                  <i className='i-search i-2x' />
                  <input
                    type='text'
                    className='--col-xs-12 --col-md-12 --col-lg-12 --col-xl-12'
                    placeholder={messageUtility.getMessage('I-000-090')}
                    defaultValue={this.state.condition.name}
                    onChange={e => this.setCondition(e.target.value)}
                  />
                </div>
                <div className='dropdown-single-select__item'>
                  <FormDropdownClearButton
                    onClick={() => this.clearSelectedRow()}
                  />
                </div>
                <div className='dropdown-single-select__item'>
                  <div
                    className='dropdown-single-select__scroll'
                    id={this.targetId}
                  >
                    <ul className='single-select'>
                      {_.map(options, (option, index) => (
                        <SelectableOption
                          key={index}
                          option={option}
                          checked={
                            checked.category_code === option.category_code
                          }
                          targetId={this.id}
                          handleSelectedRow={this.handleSelectedRow}
                        />
                      ))}
                      <InfinityScrollLoad
                        targetId={this.targetId}
                        total={_.size(options)}
                        isLoading={this.state.isLoading}
                        callback={this.getFieldImageskeyplan}
                      />
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className='form-list__alert show'>{this.props.error}</div>
        </div>
        <div className='form-list__element-keyplan'>
          <div className='form-list__element-keyplan-image'>
            <img
              id='keyplan-image'
              src={this.props.imageUrl}
              alt=''
              key={_.random(1, true)}
            />
            <input id='keyplan-image-val' type='hidden' />
            <input
              id='keyplan-image-obj'
              type='hidden'
              value={this.props.imageJson}
            />
            <input id='keyplan-image-obj-tmp' type='hidden' />
          </div>
          {this.props.imageUrl && (
            <button
              className='form-list__element-keyplan-button--delete'
              onClick={() => {
                this.deleteKeyplan();
              }}
            >
              <TrashIcon className='icon--2_4x form-list__trash-icon' />
            </button>
          )}
        </div>
      </FormElement>
    );
  }
}

/**
 * @description ドロップダウン内キープラン情報
 * @param {object} option キープラン情報
 * @param {boolean} checked true: 選択, false: 未選択
 * @param {int} targetId ユニークID
 * @param {function} handleSelectedRow ラジオボタンチェック
 */
const SelectableOption = ({ option, checked, targetId, handleSelectedRow }) => (
  <li className='single-select__item'>
    <label
      className='radio'
      htmlFor={`single-field-images-keyplan-${
        option.category_code
      }-${targetId}`}
    >
      <input
        id={`single-field-images-keyplan-${option.category_code}-${targetId}`}
        type='radio'
        checked={checked}
        onChange={() => handleSelectedRow(option, true)}
      />
      <RadioButtonIcon className='icon--1_6x' />
      <span className='single-select__label-text'>
        {`${option.label} : ${option.comment}`}
      </span>
    </label>
  </li>
);



// WEBPACK FOOTER //
// ./src/components/dropdowns/single/FieldImagesKeyplanMaster.jsx